import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { CreateFormulaCardResponse, CreateFormulaCardVariables } from '../types';

const createFormulaCardMutation = gql`
  mutation OvertimeCreateFormulaCard($input: CreateOTFormulaCardInput!) {
    overtimeCreateFormulaCard(input: $input) {
      code
      success
      message
      data {
        otFormulaCard {
          id
          name
          rateType
          rateUnit
          flatRate
          multiplier
          dailyAllowance
          formulaTemplate
          status
          createdAt
          updatedAt
          createdBy
        }
      }
    }
  }
`;

const createFormulaCard = (queryVariables: CreateFormulaCardVariables) => {
  return graphQLApi<CreateFormulaCardResponse, CreateFormulaCardVariables>({
    query: createFormulaCardMutation,
    queryVariables,
  });
};

export default createFormulaCard;
